import { render, staticRenderFns } from "./Twitter.vue?vue&type=template&id=87c1b194&"
import script from "./Twitter.vue?vue&type=script&lang=js&"
export * from "./Twitter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports